<template>
    <div class="pagination flex flex-row justify-center">
        <div class="mt-6 -mb-1 flex flex-wrap text-gold-500">
            <template v-for="(link, key) in links">
                <div
                    v-if="link.url === null"
                    :key="key"
                    class="cursor-default"
                    :class="{
                        'text-gray-500 border-gray-500': !link.active,
                        'text-gold-500 border-gold-500': link.active,
                        'px-2 border flex items-center hover:scale-95': link.is_prev || link.is_next,
                        'mr-4': link.is_prev,
                        'ml-4': link.is_next,
                        'border-l-0': !link.is_next && !link.is_prev && key > 1,
                        'page-number btn-flat border border-l-0 px-2 tablet:px-4 py-2': !link.is_prev && !link.is_next,
                    }"
                >
                    <svg-icon
                        v-if="link.is_prev"
                        class="w-6 h-6 inline-block transform rotate-180"
                        icon="arrow-horizontal" />
                    <span v-if="!link.is_prev && !link.is_next">{{ link.label }}</span>
                    <svg-icon
                        v-if="link.is_next"
                        class="w-6 h-6 inline-block"
                        icon="arrow-horizontal" />
                </div>
                <inertia-link
                    v-else
                    :key="key"
                    :class="{
                        'text-gray-500 border-gray-500': !link.active,
                        'text-gold-500 border-gold-500 touching-edges': link.active,
                        'px-2 border mr-4 flex items-center hover:scale-95 hover:z-10': link.is_prev || link.is_next,
                        'mr-4': link.is_prev,
                        'ml-4': link.is_next,
                        'border-l-0': !link.is_next && !link.is_prev && key > 1 && ! link.active,
                        'page-number btn-flat border px-2 tablet:px-4 py-2': !link.is_prev && !link.is_next,
                        'hover:text-white': ! link.active,
                    }"
                    :href="link.url">
                    <svg-icon
                        v-if="link.is_prev"
                        class="w-6 h-6 inline-block transform rotate-180"
                        icon="arrow-horizontal" />
                    <span v-if="!link.is_prev && !link.is_next">{{ link.label }}</span>
                    <svg-icon
                        v-if="link.is_next"
                        class="w-6 h-6 inline-block"
                        icon="arrow-horizontal" />
                </inertia-link>
            </template>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  name: 'Pagination',
  components: { SvgIcon },
  props: {
    links: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>

    .touching-edges {
        margin-left: -1px;
    }

</style>
